import { render, staticRenderFns } from "./SalesmanList.vue?vue&type=template&id=2c08e18e&scoped=true&"
import script from "./SalesmanList.vue?vue&type=script&lang=js&"
export * from "./SalesmanList.vue?vue&type=script&lang=js&"
import style0 from "./SalesmanList.vue?vue&type=style&index=0&id=2c08e18e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08e18e",
  null
  
)

export default component.exports